module.exports = __webpack_public_path__ + "static/img/g_legs_wr.44157446.webp";